var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_5",
    width: 31.8,
    height: 31.8,
    viewBox: "0 0 31.8 31.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#414141}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    d: "M16.2 32.1a15.9 15.9 0 1 1 15.9-15.9 15.915 15.915 0 0 1-15.9 15.9zm0-30.161A14.261 14.261 0 1 0 30.461 16.2 14.271 14.271 0 0 0 16.2 1.939z",
    className: "cls-1",
    "data-name": "Path 94",
    transform: "translate(-.3 -.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_30",
    d: "M0 0h17.703v1.639H0z",
    className: "cls-1",
    "data-name": "Rectangle 30",
    transform: "translate(7.048 9.835)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_31",
    d: "M0 0h17.703v1.639H0z",
    className: "cls-1",
    "data-name": "Rectangle 31",
    transform: "translate(7.048 15.08)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_32",
    d: "M0 0h17.703v1.639H0z",
    className: "cls-1",
    "data-name": "Rectangle 32",
    transform: "translate(7.048 20.326)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.27709fad4b50e31c3c33415a73ac37a5.svg";
export { ForwardRef as ReactComponent };